import { Mqtt_Topics_deviceChanges } from "../Optiscan.Models/Api/Api.js";
import { singleton } from "../fable_modules/fable-library.3.7.12/List.js";
import { Msg } from "./InFormTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_deviceChanges(uid)), (arg0) => (new Msg(2, arg0))];
}

